import React from "react";

export default function Contact() {
  return (
    <div className='about'>
      <h2>Contact</h2>
      <div>
        <address>We are located at: Dallas-Fort Worth Metroplex, TX USA</address>
      </div>
      <div>
        <h4>If you would like to <a href='https://www.linkedin.com/in/renatafd/?locale=en_US'>contact</a> the creator of this app for more details, click on the link.</h4>
      </div>
    </div>
  );
}
